import { useState } from 'react';
import { Activity, ArrowRight, Flag } from 'lucide-react';
import type { Entity } from './types';

type Props = {
  entity: Entity;
  main?: Entity;
  onAnswer: (answer: string, minutes?: number, note?: string, energy?: number) => void;
};

export default function CheckinModal({ entity, main, onAnswer }: Props) {
  const [note, setNote] = useState('');
  const [energy, setEnergy] = useState(3);
  const reason = entity.data.reason;
  const isDayStart = reason === 'day-start';
  const heading = isDayStart ? '今天准备从哪里开始？' : reason === 'leisure' ? '还要继续吗？' : '你现在在做什么？';

  return (
    <div className="overlay">
      <div className="checkin" role="dialog" aria-modal="true" aria-labelledby="checkin-title">
        <span className="eyebrow">
          {isDayStart ? '一天开始前的选择' : reason === 'leisure' ? '你刚刚进入了娱乐' : reason === 'break-ended' ? '约定的休息时间到了' : '定时意识检查'}
        </span>
        <h2 id="checkin-title">{heading}</h2>
        {!isDayStart && (
          <div className="current">
            <Activity />
            <div><small>检测到</small><b>{entity.data.activity?.app || '当前活动'}</b><span>{entity.data.activity?.title || entity.data.activity?.domain}</span></div>
          </div>
        )}
        {main && (
          <div className="main-reminder">
            <Flag />
            <div><small>今天的主线</small><b>{main.data.title}</b><span>下一步：{main.data.firstStep}</span></div>
          </div>
        )}
        <div className="energy">
          <span>此刻精力</span>
          {[1, 2, 3, 4, 5].map((value) => <button className={energy === value ? 'active' : ''} key={value} onClick={() => setEnergy(value)}>{value}</button>)}
        </div>
        <input value={note} onChange={(event) => setNote(event.target.value)} placeholder="可选：记下此刻的想法" />

        {isDayStart ? (
          <>
            {main ? (
              <button className="primary wide" onClick={() => onAnswer('start', 0, note, energy)}><ArrowRight />开始第一步</button>
            ) : (
              <button className="primary wide" onClick={() => onAnswer('work', 0, note, energy)}>先去选择今日主线</button>
            )}
            <button className="quiet wide" onClick={() => onAnswer('break', 5, note, energy)}>5 分钟后再提醒</button>
          </>
        ) : (
          <>
            <button className="primary wide" onClick={() => onAnswer('return', 0, note, energy)}><ArrowRight />回到主线</button>
            <div className="breaks"><span>我决定休息</span>{[5, 10, 15].map((minutes) => <button key={minutes} onClick={() => onAnswer('break', minutes, note, energy)}>{minutes} 分钟</button>)}</div>
            <button className="text-button" onClick={() => onAnswer('work', 0, note, energy)}>当前其实是必要的工作</button>
            <button className="text-button danger" onClick={() => onAnswer('end', 0, note, energy)}>结束今天</button>
          </>
        )}
      </div>
    </div>
  );
}
